import window from "../../../lib/WindowExtended";
import {
  IProductListFilterItem,
  ProductListFilterItemBoolean,
  ProductListFilterItemRange,
  ProductListFilterItemRangeValue,
  ProductListFilterItemSelect,
  ProductListFilterItemType,
  ProductListFilterItemValueType,
} from "../../../../typescript-library";
import ProductFilterSelect from "../../productFilter/ProductFilterSelect";
import ProductFilterBoolean from "../../productFilter/ProductFilterBoolean";
import ProductFilterRangeAsSelect from "../../productFilter/ProductFilterRangeAsSelect";
import ProductFilterRange from "../../productFilter/ProductFilterRange";
import React from "react";
import {ProductListState} from "../ProductListProvider";

/**
 * Array of filter buttons, all of their corresponding `filterItem.type`
 */
export const filterItemArray = (params: {
  state: ProductListState;
  onValueSelect: (filterItem: IProductListFilterItem) => ((value: ProductListFilterItemValueType) => void) | undefined;
  onRangeSelect: (filterItem: IProductListFilterItem) => ((value: ProductListFilterItemRangeValue) => void) | undefined;
}) => {
  const {state, onRangeSelect, onValueSelect} = params;
  const tempFilterItems: JSX.Element[] = [];
  // this is done to render boolean filters at the end of the list according to the ux requirement
  const tempBooleanFilterItems: JSX.Element[] = [];

  const {filtersToShow, filtersToHide, defaultFilter} = state;
  const pageCategoryTypeObject = window.dataLayer.find((elem) => elem["Page.CategoryTypeId"] !== undefined);
  const isVariantsCategoryType =
    (pageCategoryTypeObject ? pageCategoryTypeObject["Page.CategoryTypeId"] : undefined) === "100075";

  if (state.instance) {
    const filterItemsUnsorted = Array.from(state.instance.filter.filterItems.values()).filter(
      (value) =>
        value.values.size &&
        value.count &&
        (!filtersToShow.length || filtersToShow.includes(value.field)) &&
        (!filtersToHide.length || !filtersToHide.includes(value.field)) &&
        defaultFilter?.split("=")[0] !== value.field /* See also `ProductListProvider.handleResponse()` */ &&
        (value.type === "bool" ||
          value.values.size > 1 ||
          !isVariantsCategoryType) /* By now, most of the variants pages are manufacturer-, or commodity-group-specific */,
    );

    let filterItemsSorted: IProductListFilterItem[] = [];
    if (filtersToShow.length) {
      filtersToShow.forEach((filterString) => {
        const filterItem = filterItemsUnsorted.find((fi) => fi.field === filterString);
        if (filterItem) {
          filterItemsSorted.push(filterItem);
        }
      });
    } else {
      filterItemsSorted = filterItemsUnsorted;
    }

    filterItemsSorted.forEach((filterItem) => {
      switch (filterItem.type) {
        case ProductListFilterItemType.select:
          if (filterItem.field === "top_brand") {
            break;
          }
          if (filterItem.field === "availability") {
            tempBooleanFilterItems.push(<ProductFilterBoolean
              item={filterItem as ProductListFilterItemSelect}
              key={filterItem.field}
              onSelect={onValueSelect(filterItem)}
            />);
            break;
          }
          tempFilterItems.push(
            <ProductFilterSelect
              item={filterItem as ProductListFilterItemSelect}
              key={filterItem.field}
              onSelect={onValueSelect(filterItem)}
            />,
          );
          break;
        case ProductListFilterItemType.boolean:
          tempBooleanFilterItems.push(
            <ProductFilterBoolean
              item={filterItem as ProductListFilterItemBoolean}
              key={filterItem.field}
              onSelect={onValueSelect(filterItem)}
            />,
          );
          break;
        case ProductListFilterItemType.range:
          if (filterItem.field === "percentageDiscount") {
            tempFilterItems.push(
              <ProductFilterRangeAsSelect
                item={filterItem as ProductListFilterItemRange}
                key={filterItem.field}
                onSelect={onValueSelect(filterItem)}
              />,
            );
          } else {
            tempFilterItems.push(
              <ProductFilterRange
                item={filterItem as ProductListFilterItemRange}
                key={filterItem.field}
                onSelect={onRangeSelect(filterItem)}
              />,
            );
          }
          break;
      }
    });
  }

  return [tempFilterItems, tempBooleanFilterItems];
};
